import { useState } from 'react';
import { Button, InputNumber, Typography } from '@douyinfe/semi-ui';
import { IconSave } from '@douyinfe/semi-icons';
import { validEntranceBillingLimits, type EntranceBillingLimits } from './entranceEnrollment';

const fields: {key:keyof EntranceBillingLimits;label:string;min:number;max:number}[]=[
 {key:'maxQuantity',label:'每次最多预留 Token',min:1,max:100000000},
 {key:'maxExecutionSeconds',label:'单次执行时限（秒）',min:5,max:3600},
 {key:'maxTotalExecutionSeconds',label:'累计执行时限（秒）',min:5,max:86400},
 {key:'settlementGraceSeconds',label:'结算宽限（秒）',min:60,max:604800},
 {key:'maxOperationPoints',label:'每次最多预留点数',min:1,max:1000000}
];
export function EntranceBillingLimitsForm({serviceId,initial,busy,onSave}:{serviceId:string;initial?:EntranceBillingLimits;busy:boolean;onSave:(limits:EntranceBillingLimits)=>void}){
 const [value,setValue]=useState<Partial<EntranceBillingLimits>>(initial??{});
 const valid=validEntranceBillingLimits(value as EntranceBillingLimits);
 if(!initial)return <Typography.Text type="warning">尚未读取到服务器的有效上限，请刷新后重试。</Typography.Text>;
 return <section className="enrollment-result"><Typography.Text strong>AppBoss 调用上限（可选覆盖）</Typography.Text><Typography.Text>沿用收费服务：{serviceId}</Typography.Text>
 <div className="integration-form">{fields.map(({key,label,min,max})=><label className="integration-field" key={key}><span>{label}</span><InputNumber aria-label={label} value={value[key]} disabled={busy} min={min} max={max} precision={0} onChange={(n)=>setValue((v)=>({...v,[key]:typeof n==='number'?n:undefined}))}/></label>)}</div>
 <Typography.Text type="secondary">上限用于预留与限制执行，最终按实际总 Token 结算；不会修改服务价格或原收费方式。</Typography.Text>
 <Button icon={<IconSave/>} disabled={!valid||busy} onClick={()=>onSave(value as EntranceBillingLimits)}>保存调用上限</Button>
 </section>;
}
